import {
  getPanelTop,
  getSectionTop,
  getSectionsHistoryTop,
  setConfig,
} from 'weblite-router'

setConfig({
  isInitialState() {
    const rootLocation = getPanelTop('root')?.location

    if (rootLocation === 'auth/login') return true
    if (rootLocation !== 'root/app') return false

    const activeSection = getSectionsHistoryTop()
    if (activeSection === undefined) return 'ignore'
    if (activeSection !== 'left') return false

    const leftSectionTop = getSectionTop('left')
    if (leftSectionTop !== 'home') return false

    const homePanelState = getPanelTop('home')?.state
    if (homePanelState?.tab !== 'roomList') return false

    const { location: roomListLocation, state: roomListState } =
      getPanelTop('roomList') || {}

    return roomListLocation === 'roomList/roomList' && !roomListState
  },
})
